export interface IAuthApiErrorBody {
	error?: string;
	errorDetail?: string;
}

/**
 * Estrae il messaggio utente da una risposta API auth (LoginResponse / RegisterResponse o legacy string).
 */
export function getAuthApiErrorMessage(data: unknown, fallback: string): string {
	if (typeof data === "string" && data) {
		return data;
	}

	if (data && typeof data === "object") {
		const body = data as IAuthApiErrorBody;
		if (body.errorDetail) {
			return body.errorDetail;
		}
		if (body.error) {
			return body.error;
		}
	}

	return fallback;
}

/**
 * Simula l'errore axios quando il body HTTP è già un modello Error/ErrorDetail (es. 200 anomalo o uso da action).
 */
export function throwAuthApiError(data: IAuthApiErrorBody, fallback = "Errore"): never {
	const err = Object.assign(new Error(getAuthApiErrorMessage(data, fallback)), {
		response: { data },
	});
	throw err;
}

export function assertAuthSuccessResponse(
	data: IAuthApiErrorBody,
	fallback: string
): void {
	if (data.error) {
		throwAuthApiError(data, fallback);
	}
}
